import {Component, inject, OnDestroy, OnInit, Signal} from '@angular/core';
import {BreadcrumbsComponent} from '../../../../common/breadcrumbs/breadcrumbs.component';
import {ContentComponent} from '../../../../components/content/content.component';
import {ActivatedRoute, Router, RouterLink, RouterOutlet} from '@angular/router';
import {Store} from '@ngrx/store';
import {selectServiceByUrl, selectUISettings} from '../../../../store/selectors/app.selectors';
import {loadApplication, setApplication} from '../../../../store/actions/application.actions';
import {loadUserDetails} from '../../../../store/actions/user-details.actions';
import {ServiceListItem} from '../../../../services/service.common.model';
import {Subscription} from 'rxjs';
import {selectApplication} from '../../../../store/selectors/application.selectors';
import {UISettings} from "../../../../services/ssession.service";

@Component({
  selector: 'app-edit-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    RouterOutlet
  ],
  templateUrl: './edit-page.component.html'
})
export class EditPageComponent implements OnInit, OnDestroy {

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  private store$: Store = inject(Store);

  public uiSettings: Signal<UISettings | null> = this.store$.selectSignal(selectUISettings);

  private fetchApplication: Subscription = this.store$.select(selectApplication).subscribe(v => {
    if (v?.status?.code === 'zatwierdzony') {
      this.router.navigateByUrl(`/wnioski-zatwierdzone${v.service?.url}/${v.uuid}`);
    }
    if (v?.status?.code === 'wyslany') {
      this.router.navigateByUrl(`/wnioski-wyslane${v.service?.url}/${v.uuid}`);
    }
  });

  public serviceType: Signal<ServiceListItem | null> = this.store$.selectSignal(selectServiceByUrl(this.route?.snapshot?.data['contentUrl']));

  public ngOnInit(): void {
    const id: string | undefined = this.route.snapshot.children[0]?.params['appId'];
    if (id) {
      this.store$.dispatch(loadApplication({id}));
    } else {
      this.store$.dispatch(setApplication({application: null}));
    }
    this.store$.dispatch(loadUserDetails());
  }

  public ngOnDestroy(): void {
    this.store$.dispatch(setApplication({application: null}));
    this.fetchApplication.unsubscribe();
  }
}
